export default "__VITE_ASSET__CUz5JPp___"